module.exports = __webpack_public_path__ + "static/img/lxy_ani.1a5882a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/lxy_ani.png
// module id = 0GRn
// module chunks = 5